import { updateItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-2">
          最新上架
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          片库每日更新，最新动态一网打尽，好电影从不缺席
        </p>
        <div className="relative pl-6 border-l-2 border-background-300/40">
          {updateItems.map((item, idx) => (
            <div key={idx} className="relative pb-8 last:pb-0">
              <div className="absolute -left-[25px] top-0 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50"></div>
              <div className="ml-2">
                <span className="text-xs font-medium text-primary-400">{item.date}</span>
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 mt-1 mb-1">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}